var _defs, _style, _use;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 23",
    width: 30,
    height: 23,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Layer 43") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("image", {
    width: 30,
    height: 23,
    id: "img1",
    href: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAXCAMAAAAr4Q9YAAAAAXNSR0IB2cksfwAAAQ5QTFRF////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////7ilbVgAAAFp0Uk5TACqe5u7t6q8/ARjv//o583JvcG7fzntFazUICgcMEMHaYARLy9ckF+LIPLA0Jq78rCEUkPfFOgJGyfKLDQPn3lsFBmnd5Ox+hZsaHy37dkC5YV7U1iD+QjZMO6PwgAAAANZJREFUeJxjZGAEAQYsACzBhV0OpoCdlRmn7h+cjLz/uV7h0Cz+lYGRh4HnBQ5pyc9ESksxPkWRkWF8jCQtB/LDPYSsMpB7CyGtzviEQZbx/neok7UeMjDLXkEyXBeoF6jlPFDSiJHxBoMm4ykUp5kzMl5m0AOaeVXnHIMxI+N+dJc7MTKeYLC8/YbBivH6I2wek9bdw8GgIcq4DZe/vX9csNxCerAMjLTvfqdNOKT99zIwBuyx4r5ggE2WkXGnB2Po/Rs4NDMweAFTWcRl6f3YZaWsNgAA/AZJxCjD+FgAAAAASUVORK5CYII="
  }))), _style || (_style = /*#__PURE__*/React.createElement("style", null)), _use || (_use = /*#__PURE__*/React.createElement("use", {
    id: "Layer 43",
    href: "#img1",
    x: 0,
    y: 0
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailIcon);
export default __webpack_public_path__ + "static/media/email-icon.cf372bf235ead2902cf6f89d05a088f4.svg";
export { ForwardRef as ReactComponent };